<template>
  <!-- TODO: Should this be wrapped in <NuxtLayout name="default"></NuxtLayout>? -->
  <!-- What does prod look like currently? -->
  <div class="flex flex-col max-w-2xl mx-auto mt-16 md:mt-32 items-center">
    <h1 class="text-4xl font-bold text-plum-darkest mt-6">
      Oops!
    </h1>
    <h3
      class="text-xl mt-2 text mb-4 text-gray-darkest"
      data-cypress="error-message"
    >
      {{ errObj.message }}
    </h3>
    <openly-button-anchor
      :to="buttonUrl"
    >
      {{ buttonText }}
    </openly-button-anchor>
  </div>
</template>

<script>

export default {
  name: 'Error',
  setup() {
    // TODO: This might be how we want this to work, but we should consider moving this data around when we call `createError()`.
    // This could make the error page more flexible.
    const globalError = useError()

    return {
      // Note: This used to be called `error`, but in nuxt test utils returning `error` here results in `this` === `{}` in the computeds, causing errors.
      // `error` is not listed anywhere as a reserved name and it works when running the app normally.
      // TODO: I need to document this `this` === `{}` behavior to help folks debug this if they encounter it.
      errObj: globalError.value,
    }
  },
  computed: {
    buttonText() {
      return this.errObj.data?.buttonText ?? 'Return to Dashboard'
    },
    buttonUrl() {
      return this.errObj.data?.buttonUrl || '/'
    },
  },
}
</script>
